import { forwardRef, cloneElement, useImperativeHandle } from 'react';
import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DeliveryDateDynamic = dynamic(() => import('./delivery-date'), { ssr: false });

const DeliveryDate = forwardRef((props: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  let { children, onShow, ...rest } = props;

  useImperativeHandle(ref, () => {
    return {
      show
    };
  });

  return (
    <>
      {cloneElement(children, {
        onClick: e => {
          show(e);
          onShow?.(e);
        }
      })}
      {loaded && <DeliveryDateDynamic {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});

export default DeliveryDate;
